import { render, staticRenderFns } from "./EventsTab.vue?vue&type=template&id=97457266&scoped=true&lang=pug"
import script from "./EventsTab.vue?vue&type=script&lang=js"
export * from "./EventsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97457266",
  null
  
)

export default component.exports